// Generated from Func.g4 by ANTLR 4.5.1
// jshint ignore: start
var antlr4 = require('antlr4/index');

var serializedATN = [
  '\u0003\u0430\ud6d1\u8206\uad2d\u4417\uaef1\u8d80\uaadd',
  '\u0002\u001a\u0096\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004',
  '\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t',
  '\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004',
  '\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010',
  '\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013',
  '\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017',
  '\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a',
  '\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0003\u0002\u0003\u0002\u0003',
  '\u0002\u0003\u0002\u0003\u0002\u0007\u0002?\n\u0002\f\u0002\u000e\u0002',
  'B\u000b\u0002\u0003\u0003\u0003\u0003\u0003\u0004\u0003\u0004\u0003',
  '\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006M',
  '\n\u0006\f\u0006\u000e\u0006P\u000b\u0006\u0003\u0006\u0003\u0006\u0003',
  '\u0006\u0003\u0006\u0007\u0006V\n\u0006\f\u0006\u000e\u0006Y\u000b\u0006',
  '\u0003\u0006\u0005\u0006\\\n\u0006\u0003\u0007\u0003\u0007\u0003\u0007',
  '\u0005\u0007a\n\u0007\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003',
  '\b\u0003\t\u0003\t\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003\f\u0003',
  '\f\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000f\u0003\u000f\u0003',
  '\u0010\u0003\u0010\u0003\u0011\u0003\u0011\u0003\u0012\u0003\u0012\u0003',
  '\u0013\u0003\u0013\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003',
  '\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0018\u0005\u0018\u0088',
  '\n\u0018\u0003\u0019\u0003\u0019\u0003\u001a\u0003\u001a\u0003\u001b',
  '\u0003\u001b\u0003\u001c\u0006\u001c\u0091\n\u001c\r\u001c\u000e\u001c',
  '\u0092\u0003\u001c\u0003\u001c\u0002\u0002\u001d\u0003\u0003\u0005\u0004',
  '\u0007\u0005\t\u0006\u000b\u0007\r\u0002\u000f\u0002\u0011\u0002\u0013',
  '\b\u0015\t\u0017\n\u0019\u000b\u001b\f\u001d\r\u001f\u000e!\u000f#\u0010',
  "%\u0011'\u0012)\u0013+\u0014-\u0015/\u00161\u00173\u00185\u00197\u001a",
  '\u0003\u0002\b\u0004\u0002$$^^\u0004\u0002))^^\n\u0002$$11^^ddhhppt',
  'tvv\u0005\u00022;CHch\u0006\u0002//C\\aac|\u0005\u0002\u000b\f\u000f',
  '\u000f""\u009c\u0002\u0003\u0003\u0002\u0002\u0002\u0002\u0005\u0003',
  '\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002\t\u0003',
  '\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002\u0013\u0003',
  '\u0002\u0002\u0002\u0002\u0015\u0003\u0002\u0002\u0002\u0002\u0017\u0003',
  '\u0002\u0002\u0002\u0002\u0019\u0003\u0002\u0002\u0002\u0002\u001b\u0003',
  '\u0002\u0002\u0002\u0002\u001d\u0003\u0002\u0002\u0002\u0002\u001f\u0003',
  '\u0002\u0002\u0002\u0002!\u0003\u0002\u0002\u0002\u0002#\u0003\u0002',
  "\u0002\u0002\u0002%\u0003\u0002\u0002\u0002\u0002'\u0003\u0002\u0002",
  '\u0002\u0002)\u0003\u0002\u0002\u0002\u0002+\u0003\u0002\u0002\u0002',
  '\u0002-\u0003\u0002\u0002\u0002\u0002/\u0003\u0002\u0002\u0002\u0002',
  '1\u0003\u0002\u0002\u0002\u00023\u0003\u0002\u0002\u0002\u00025\u0003',
  '\u0002\u0002\u0002\u00027\u0003\u0002\u0002\u0002\u00039\u0003\u0002',
  '\u0002\u0002\u0005C\u0003\u0002\u0002\u0002\u0007E\u0003\u0002\u0002',
  '\u0002\tG\u0003\u0002\u0002\u0002\u000b[\u0003\u0002\u0002\u0002\r]',
  '\u0003\u0002\u0002\u0002\u000fb\u0003\u0002\u0002\u0002\u0011h\u0003',
  '\u0002\u0002\u0002\u0013j\u0003\u0002\u0002\u0002\u0015l\u0003\u0002',
  '\u0002\u0002\u0017n\u0003\u0002\u0002\u0002\u0019p\u0003\u0002\u0002',
  '\u0002\u001br\u0003\u0002\u0002\u0002\u001dt\u0003\u0002\u0002\u0002',
  '\u001fv\u0003\u0002\u0002\u0002!x\u0003\u0002\u0002\u0002#z\u0003\u0002',
  "\u0002\u0002%|\u0003\u0002\u0002\u0002'~\u0003\u0002\u0002\u0002)\u0080",
  '\u0003\u0002\u0002\u0002+\u0082\u0003\u0002\u0002\u0002-\u0084\u0003',
  '\u0002\u0002\u0002/\u0087\u0003\u0002\u0002\u00021\u0089\u0003\u0002',
  '\u0002\u00023\u008b\u0003\u0002\u0002\u00025\u008d\u0003\u0002\u0002',
  '\u00027\u0090\u0003\u0002\u0002\u00029:\u0007?\u0002\u0002:@\u0005/',
  '\u0018\u0002;?\u0005/\u0018\u0002<?\u00051\u0019\u0002=?\u0005)\u0015',
  '\u0002>;\u0003\u0002\u0002\u0002><\u0003\u0002\u0002\u0002>=\u0003\u0002',
  '\u0002\u0002?B\u0003\u0002\u0002\u0002@>\u0003\u0002\u0002\u0002@A\u0003',
  '\u0002\u0002\u0002A\u0004\u0003\u0002\u0002\u0002B@\u0003\u0002\u0002',
  "\u0002CD\u0007B\u0002\u0002D\u0006\u0003\u0002\u0002\u0002EF\u0007'",
  '\u0002\u0002F\b\u0003\u0002\u0002\u0002GH\u0007A\u0002\u0002H\n\u0003',
  '\u0002\u0002\u0002IN\u0007$\u0002\u0002JM\u0005\r\u0007\u0002KM\n\u0002',
  '\u0002\u0002LJ\u0003\u0002\u0002\u0002LK\u0003\u0002\u0002\u0002MP\u0003',
  '\u0002\u0002\u0002NL\u0003\u0002\u0002\u0002NO\u0003\u0002\u0002\u0002',
  'OQ\u0003\u0002\u0002\u0002PN\u0003\u0002\u0002\u0002Q\\\u0007$\u0002',
  '\u0002RW\u0007)\u0002\u0002SV\u0005\r\u0007\u0002TV\n\u0003\u0002\u0002',
  'US\u0003\u0002\u0002\u0002UT\u0003\u0002\u0002\u0002VY\u0003\u0002\u0002',
  '\u0002WU\u0003\u0002\u0002\u0002WX\u0003\u0002\u0002\u0002XZ\u0003\u0002',
  '\u0002\u0002YW\u0003\u0002\u0002\u0002Z\\\u0007)\u0002\u0002[I\u0003',
  '\u0002\u0002\u0002[R\u0003\u0002\u0002\u0002\\\f\u0003\u0002\u0002\u0002',
  ']`\u0007^\u0002\u0002^a\t\u0004\u0002\u0002_a\u0005\u000f\b\u0002`^',
  '\u0003\u0002\u0002\u0002`_\u0003\u0002\u0002\u0002a\u000e\u0003\u0002',
  '\u0002\u0002bc\u0007w\u0002\u0002cd\u0005\u0011\t\u0002de\u0005\u0011',
  '\t\u0002ef\u0005\u0011\t\u0002fg\u0005\u0011\t\u0002g\u0010\u0003\u0002',
  '\u0002\u0002hi\t\u0005\u0002\u0002i\u0012\u0003\u0002\u0002\u0002jk',
  '\u0007*\u0002\u0002k\u0014\u0003\u0002\u0002\u0002lm\u0007+\u0002\u0002',
  'm\u0016\u0003\u0002\u0002\u0002no\u0007]\u0002\u0002o\u0018\u0003\u0002',
  '\u0002\u0002pq\u0007_\u0002\u0002q\u001a\u0003\u0002\u0002\u0002rs\u0007',
  '-\u0002\u0002s\u001c\u0003\u0002\u0002\u0002tu\u0007/\u0002\u0002u\u001e',
  '\u0003\u0002\u0002\u0002vw\u0007,\u0002\u0002w \u0003\u0002\u0002\u0002',
  'xy\u00071\u0002\u0002y"\u0003\u0002\u0002\u0002z{\u0007@\u0002\u0002',
  '{$\u0003\u0002\u0002\u0002|}\u0007>\u0002\u0002}&\u0003\u0002\u0002',
  '\u0002~\u007f\u0007?\u0002\u0002\u007f(\u0003\u0002\u0002\u0002\u0080',
  '\u0081\u0007A\u0002\u0002\u0081*\u0003\u0002\u0002\u0002\u0082\u0083',
  '\u00070\u0002\u0002\u0083,\u0003\u0002\u0002\u0002\u0084\u0085\u0007',
  '`\u0002\u0002\u0085.\u0003\u0002\u0002\u0002\u0086\u0088\t\u0006\u0002',
  '\u0002\u0087\u0086\u0003\u0002\u0002\u0002\u00880\u0003\u0002\u0002',
  '\u0002\u0089\u008a\u00042;\u0002\u008a2\u0003\u0002\u0002\u0002\u008b',
  '\u008c\u0007.\u0002\u0002\u008c4\u0003\u0002\u0002\u0002\u008d\u008e',
  '\u0007(\u0002\u0002\u008e6\u0003\u0002\u0002\u0002\u008f\u0091\t\u0007',
  '\u0002\u0002\u0090\u008f\u0003\u0002\u0002\u0002\u0091\u0092\u0003\u0002',
  '\u0002\u0002\u0092\u0090\u0003\u0002\u0002\u0002\u0092\u0093\u0003\u0002',
  '\u0002\u0002\u0093\u0094\u0003\u0002\u0002\u0002\u0094\u0095\b\u001c',
  '\u0002\u0002\u00958\u0003\u0002\u0002\u0002\r\u0002>@LNUW[`\u0087\u0092',
  '\u0003\u0002\u0003\u0002',
].join('');

var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.dfa.DFA(ds, index);
});

function FuncLexer(input) {
  antlr4.Lexer.call(this, input);
  this._interp = new antlr4.atn.LexerATNSimulator(
    this,
    atn,
    decisionsToDFA,
    new antlr4.PredictionContextCache(),
  );
  return this;
}

FuncLexer.prototype = Object.create(antlr4.Lexer.prototype);
FuncLexer.prototype.constructor = FuncLexer;

FuncLexer.EOF = antlr4.Token.EOF;
FuncLexer.FNAME = 1;
FuncLexer.ATNAME = 2;
FuncLexer.PNAME = 3;
FuncLexer.ENAME = 4;
FuncLexer.STRING = 5;
FuncLexer.LPAREN = 6;
FuncLexer.RPAREN = 7;
FuncLexer.LBRACKET = 8;
FuncLexer.RBRACKET = 9;
FuncLexer.PLUS = 10;
FuncLexer.MINUS = 11;
FuncLexer.TIMES = 12;
FuncLexer.DIV = 13;
FuncLexer.GT = 14;
FuncLexer.LT = 15;
FuncLexer.EQ = 16;
FuncLexer.QM = 17;
FuncLexer.POINT = 18;
FuncLexer.CARET = 19;
FuncLexer.LETTER = 20;
FuncLexer.DIGIT = 21;
FuncLexer.COMMA = 22;
FuncLexer.AMP = 23;
FuncLexer.WS = 24;

FuncLexer.modeNames = ['DEFAULT_MODE'];

FuncLexer.literalNames = [
  'null',
  'null',
  "'@'",
  "'%'",
  'null',
  'null',
  "'('",
  "')'",
  "'['",
  "']'",
  "'+'",
  "'-'",
  "'*'",
  "'/'",
  "'>'",
  "'<'",
  "'='",
  'null',
  "'.'",
  "'^'",
  'null',
  'null',
  "','",
  "'&'",
];

FuncLexer.symbolicNames = [
  'null',
  'FNAME',
  'ATNAME',
  'PNAME',
  'ENAME',
  'STRING',
  'LPAREN',
  'RPAREN',
  'LBRACKET',
  'RBRACKET',
  'PLUS',
  'MINUS',
  'TIMES',
  'DIV',
  'GT',
  'LT',
  'EQ',
  'QM',
  'POINT',
  'CARET',
  'LETTER',
  'DIGIT',
  'COMMA',
  'AMP',
  'WS',
];

FuncLexer.ruleNames = [
  'FNAME',
  'ATNAME',
  'PNAME',
  'ENAME',
  'STRING',
  'ESC',
  'UNICODE',
  'HEX',
  'LPAREN',
  'RPAREN',
  'LBRACKET',
  'RBRACKET',
  'PLUS',
  'MINUS',
  'TIMES',
  'DIV',
  'GT',
  'LT',
  'EQ',
  'QM',
  'POINT',
  'CARET',
  'LETTER',
  'DIGIT',
  'COMMA',
  'AMP',
  'WS',
];

FuncLexer.grammarFileName = 'Func.g4';

exports.FuncLexer = FuncLexer;
